import { set, when } from 'cerebral/operators'
import { state, props } from 'cerebral/tags'
import showDialog from 'modules/App/factories/showDialog'
import moveNode from '../chains/moveNode'

export default [
  when(state`node.moveAlertTime.date`),
  {
    true: [
      when(
        state`node.moveAlertTime.date`,
        state`node.moveAlertTime.millis`,
        (date, millis) => millis + date > new Date().getTime()
      ),
      {
        true: [set(props`showDialog`, false)],
        false: [set(props`showDialog`, true)]
      }
    ],
    false: [set(props`showDialog`, true)]
  },
  when(props`showDialog`),
  {
    true: [
      showDialog({
        type: 'confirm',
        title: {
          key: 'bms.node.dialog.move.title'
        },
        content: {
          key: 'bms.node.dialog.move.content',
          params: {
            node: props`node.title`
          }
        },
        confirm: {
          signal: 'node.moveNode',
          args: {
            node: props`node`,
            nearestTopLeaf: props`nearestTopLeaf`,
            parentId: props`parentId`
          }
        },
        dismiss: {
          signal: 'node.revokeMove',
          args: {
            node: props`node`
          }
        },
        checkOption: {
          checked: {
            signal: 'node.setMoveAlertTime'
          },
          unchecked: {
            signal: 'node.unsetMoveAlertTime'
          },
          title: 'bms.node.dialog.moveNode.checkOption'
        }
      })
    ],
    false: [...moveNode]
  }
]



// WEBPACK FOOTER //
// ./src/modules/Node/chains/onBeforeMoveNode.js